import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import { getFormattedNumber } from '../../../../../../../../globs/utils/common';
import LeftStars from './left-stars.svg';
import RightStars from './right-stars.svg';

const Rebate = ({ order, user }) => {
  if (!order.target_data || order.target_data.length === 0 ||
    !order.target_data.every(data => data.rebate)) {
    return null;
  }

  let currTargetData = null;
  let prevTargetData = null;
  let hasAcheivedCurrTarget = false;
  for (let i = 0; i < order.target_data.length; i += 1) {
    const data = order.target_data[i];
    if (order.total_quantity < data.target) {
      hasAcheivedCurrTarget = false;
      if (currTargetData && currTargetData.target !== null) {
        prevTargetData = currTargetData;
      }
      currTargetData = data;
      break;
    } else {
      currTargetData = data;
      hasAcheivedCurrTarget = true;
    }
  }

  const getFormattedNumber = (val) => {
    return val;
  }

  // console.log('prevTarget', prevTargetData && prevTargetData.target);
  // console.log('currTarget', currTargetData && currTargetData.target);
  // console.log('hasAcheivedCurrTarget', hasAcheivedCurrTarget);
  let message = '';
  console.log('props>>>>', user);

  if (prevTargetData) {
    if (hasAcheivedCurrTarget) {
      const rebate = currTargetData.rebate * 20 * order.total_quantity;
      message = `You have already accumulated a rebate of ${getFormattedNumber(rebate)} ${user.currency}. Keep going !!`;
    } else {
      const prevRebate = prevTargetData.rebate * 20 * order.total_quantity;
      const currRebate = currTargetData.rebate * 20 * currTargetData.target;
      message = `You have already a rebate of ${getFormattedNumber(prevRebate)} ${user.currency}. Reach ${getFormattedNumber(currTargetData.target)} ton in ${moment().format('MMMM')} and get a total rebate of ${getFormattedNumber(currRebate)} ${user.currency}`;
    }
  } else if (hasAcheivedCurrTarget) {
    const rebate = currTargetData.rebate * 20 * order.total_quantity;
    message = `You have already accumulated a rebate of ${getFormattedNumber(rebate)} ${user.currency}. Keep going !!`;
  } else {
    const rebate = currTargetData.rebate * 20 * currTargetData.target;
    message = `Reach ${getFormattedNumber(currTargetData.target)} tons in ${moment().format('MMMM')} and get a rebate of ${getFormattedNumber(rebate)} ${user.currency}`;
  }

  return (
    <div className="show-rebate">
      <img src={LeftStars} alt="LStars" />
      <p>{message}</p>
      <img src={RightStars} alt="RStars" />
    </div>
  );
};

Rebate.propTypes = {
  order: PropTypes.shape({}),
  user: PropTypes.shape({
    currency: PropTypes.string,
  }).isRequired,

};

Rebate.defaultProps = {
  order: {
    target_data: PropTypes.arrayOf(PropTypes.shape({})),
    total_quantity: PropTypes.number,
  },
};

export default Rebate;
